export default "__VITE_ASSET__BJPpT4ae__"